import { Dayjs } from "dayjs";
import { City } from "../searchTab/flights/RoutePickerModel";

export interface CurrentStatusSearch {
	date: Dayjs;
	destinationCity: City;
	originCity: City;
}

export const DEFAULT_CURRENT_STATUS_SEARCH: CurrentStatusSearch = {
	date: undefined,
	destinationCity: undefined,
	originCity: undefined,
};
